import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: 'hlm-select, brn-select [hlm]',
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmSelect {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() => hlm('w-full p-0 gap-xs rounded-xxs min-w-0', this.userClass()));
}
